module.exports = __webpack_public_path__ + "static/media/user-profile.21788b90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/user-profile.svg
// module id = 1145
// module chunks = 0